import type { IconData } from '@stacksjs/iconify-core'

export const contentDislike: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4 16a4 4 0 0 0 4-4v-1h8V8a8 8 0 0 0-8-8H4zm-1.5-5H0V0h2.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentDislike
